import React, { useEffect, useState } from "react";
import {
    Card,
    Row,
    Col,
    Button,
    Upload,
    Divider,
    Space,
    Typography,
    message,
    Tag
} from "antd";

import {
    Trash2,
    X,
} from "lucide-react";

import { Modal, Tooltip } from "antd";

import dayjs from "dayjs";
import {
    DownloadOutlined,
    InboxOutlined,
    UploadOutlined,
} from "@ant-design/icons";
import { AlertTriangle } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import * as XLSX from "xlsx";

import {
    downloadIoDeletionTemplate,
    uploadIoDeletion,
    getIoDeletionLogs,
    getIoDeletionList,
    ignoreIoDeletion,
    deleteIoDeletion,
} from "../../redux/adminUnitReportSlice/adminUnitReportSlice";

import CustomTable from "../../components/Common/CustomTable/CustomTable";

const { Dragger } = Upload;

const DeleteRevNo = () => {
    const dispatch = useDispatch();

    const {
        downloadingIoDeletionTemplate,
        uploadingIoDeletion,
        gettingIoDeletionLogs,
        ioDeletionLogs,
        ioDeletionLogsPagination,

        gettingIoDeletionList,
        ioDeletionList,
        ioDeletionListPagination,

        deletingIoDeletion,
        ignoringIoDeletion,
    } = useSelector((state) => state.unitReport);

    const [selectedFile, setSelectedFile] = useState(null);

    const [modalOpen, setModalOpen] = useState(false);
    const [modalType, setModalType] = useState(null); // "delete" | "ignore"
    const [selectedRecord, setSelectedRecord] = useState(null);


    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
    });

    const [listPagination, setListPagination] = useState({
        page: 1,
        limit: 10,
    });

    const fetchDeletionList = (page = 1, limit = 10) => {
        dispatch(
            getIoDeletionList({
                page,
                limit,
            })
        );
    };

    useEffect(() => {
        fetchLogs(
            pagination.page,
            pagination.limit
        );

        fetchDeletionList(
            listPagination.page,
            listPagination.limit
        );
    }, []);

    const fetchLogs = (page = 1, limit = 10) => {
        dispatch(
            getIoDeletionLogs({
                page,
                limit,
            })
        );
    };

    // const handleDelete = (record) => {
    //     Modal.confirm({
    //         centered: true,
    //         width: 500,
    //         title: (
    //             <span className="flex items-center gap-2">
    //                 <AlertTriangle
    //                     size={18}
    //                     color="#D92D20"
    //                     strokeWidth={2.2}
    //                 />
    //                 <span>Delete IO?</span>
    //             </span>
    //         ),
    //         icon: null,
    //         okText: "Delete",
    //         cancelText: "Cancel",
    //         okButtonProps: {
    //             danger: true,
    //             loading: deletingIoDeletion,
    //         },

    //         content: (
    //             <div className="mt-4">
    //                 <p className="text-[#475467]">
    //                     You are about to permanently delete the following Internal Order.
    //                 </p>

    //                 <div className="mt-4 rounded-lg border border-red-200 bg-red-50 p-4 space-y-2">
    //                     <div>
    //                         <span className="font-semibold">IO No:</span>{" "}
    //                         {record.IO_NO}
    //                     </div>

    //                     <div>
    //                         <span className="font-semibold">REV No:</span>{" "}
    //                         {record.REV_NO}
    //                     </div>

    //                     <div>
    //                         <span className="font-semibold">
    //                             Manufacturing Unit:
    //                         </span>{" "}
    //                         {record.MNF_UNIT}
    //                     </div>
    //                 </div>

    //                 <div className="mt-4 rounded-lg border border-[#FDA29B] bg-[#FEF3F2] p-3">
    //                     <p className="text-[#B42318] font-medium mb-1">
    //                         Warning
    //                     </p>

    //                     <p className="text-[#B42318] text-sm">
    //                         This action is permanent and cannot be undone.
    //                         Please make sure you want to delete this IO before
    //                         proceeding.
    //                     </p>
    //                 </div>
    //             </div>
    //         ),

    //         onOk: () =>
    //             dispatch(deleteIoDeletion({ id: record.ID })).then((res) => {
    //                 if (res.meta.requestStatus === "fulfilled") {
    //                     fetchDeletionList(
    //                         listPagination.page,
    //                         listPagination.limit
    //                     );

    //                     fetchLogs(
    //                         pagination.page,
    //                         pagination.limit
    //                     );
    //                 }
    //             }),
    //     });
    // };


    // const handleIgnore = (record) => {
    //     Modal.confirm({
    //         centered: true,
    //         width: 500,
    //         title: "Ignore Deletion Request?",
    //         okText: "Ignore",
    //         cancelText: "Cancel",

    //         okButtonProps: {
    //             loading: ignoringIoDeletion,
    //         },

    //         content: (
    //             <div className="mt-4">
    //                 <p className="text-[#475467]">
    //                     This deletion request will be ignored and removed from the
    //                     pending deletion list.
    //                 </p>

    //                 <div className="mt-4 rounded-lg border border-[#D0D5DD] bg-[#F9FAFB] p-4 space-y-2">
    //                     <div>
    //                         <span className="font-semibold">IO No:</span>{" "}
    //                         {record.IO_NO}
    //                     </div>

    //                     <div>
    //                         <span className="font-semibold">REV No:</span>{" "}
    //                         {record.REV_NO}
    //                     </div>

    //                     <div>
    //                         <span className="font-semibold">
    //                             Manufacturing Unit:
    //                         </span>{" "}
    //                         {record.MNF_UNIT}
    //                     </div>
    //                 </div>
    //             </div>
    //         ),

    //         onOk: () =>
    //             dispatch(ignoreIoDeletion({ id: record.ID })).then((res) => {
    //                 if (res.meta.requestStatus === "fulfilled") {
    //                     fetchDeletionList(
    //                         listPagination.page,
    //                         listPagination.limit
    //                     );

    //                     fetchLogs(
    //                         pagination.page,
    //                         pagination.limit
    //                     );
    //                 }
    //             }),
    //     });
    // };


    const handleDelete = (record) => {
        setSelectedRecord(record);
        setModalType("delete");
        setModalOpen(true);
    };

    const handleIgnore = (record) => {
        setSelectedRecord(record);
        setModalType("ignore");
        setModalOpen(true);
    };

    const handleConfirm = () => {
        const action =
            modalType === "delete"
                ? deleteIoDeletion({ id: selectedRecord.ID })
                : ignoreIoDeletion({ id: selectedRecord.ID });

        dispatch(action).then((res) => {
            if (res.meta.requestStatus === "fulfilled") {
                setModalOpen(false);

                fetchDeletionList(
                    listPagination.page,
                    listPagination.limit
                );

                fetchLogs(
                    pagination.page,
                    pagination.limit
                );
            }
        });
    };

    const handlePagination = (page, pageSize) => {
        setPagination({
            page,
            limit: pageSize,
        });

        fetchLogs(page, pageSize);
    };

    const beforeUpload = (file) => {
        const isExcel =
            file.type ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
            file.type === "application/vnd.ms-excel";

        if (!isExcel) {
            message.error("Please upload an Excel file.");
            return Upload.LIST_IGNORE;
        }

        setSelectedFile(file);
        return false;
    };

    const handleUpload = () => {
        if (!selectedFile) {
            message.warning("Please select an Excel file.");
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            const workbook = XLSX.read(e.target.result, {
                type: "binary",
            });

            const worksheet =
                workbook.Sheets[workbook.SheetNames[0]];

            const excelData = XLSX.utils
                .sheet_to_json(worksheet)
                .filter((row) =>
                    Object.values(row).some(
                        (value) =>
                            value !== undefined &&
                            value !== null &&
                            value.toString().trim() !== ""
                    )
                );

            if (!excelData.length) {
                message.error("Excel file is empty.");
                return;
            }

            dispatch(
                uploadIoDeletion({
                    data: excelData,
                })
            ).then((res) => {
                if (res.meta.requestStatus === "fulfilled") {
                    setSelectedFile(null);

                    fetchDeletionList(
                        listPagination.page,
                        listPagination.limit
                    );

                    fetchLogs(
                        pagination.page,
                        pagination.limit
                    );
                }
            });
        };

        reader.readAsBinaryString(selectedFile);
    };

    const columns = [
        {
            title: "Sr. No.",
            key: "srNo",
            width: 90,
            align: "center",
            render: (_, __, index) =>
                ((ioDeletionLogsPagination?.page || pagination.page) - 1) *
                (ioDeletionLogsPagination?.limit || pagination.limit) +
                index +
                1,
        },
        {
            title: "IO No",
            dataIndex: "IO_NO",
            key: "IO_NO",
            width: 150,
        },
        {
            title: "Rev No",
            dataIndex: "REV_NO",
            key: "REV_NO",
            width: 100,
            align: "center",
        },
        {
            title: "Manufacturing Unit",
            dataIndex: "MNF_UNIT",
            key: "MNF_UNIT",
            align: "center",
        },
        {
            title: "Action",
            dataIndex: "ACTION",
            key: "ACTION",
            width: 120,
            align: "center",
            render: (value) => (
                <Tag color={value === "DELETE" ? "red" : "orange"}>
                    {value}
                </Tag>
            ),
        },
        {
            title: "Rows Affected",
            dataIndex: "ROWS_AFFECTED",
            key: "ROWS_AFFECTED",
            width: 150,
            align: "center",
        },
        {
            title: "Details",
            dataIndex: "DETAILS",
            key: "DETAILS",
            width: 220,
            render: (value) => {
                if (!value) return "-";

                try {
                    const parsed = JSON.parse(value);

                    return Object.entries(parsed)
                        .map(([k, v]) => `${k}: ${v}`)
                        .join(", ");
                } catch {
                    return value;
                }
            },
        },
        {
            title: "Performed By",
            dataIndex: "PERFORMED_BY",
            key: "PERFORMED_BY",
            width: 140,
        },
        {
            title: "Performed At",
            dataIndex: "CREATED_AT",
            key: "CREATED_AT",
            width: 180,
            render: (value) =>
                value
                    ? dayjs(value).format("DD-MM-YYYY HH:mm:ss")
                    : "-",
        },
    ];

    const pendingColumns = [
        {
            title: "Sr. No.",
            width: 90,
            render: (_, __, index) =>
                ((ioDeletionListPagination?.page || listPagination.page) - 1) *
                (ioDeletionListPagination?.limit || listPagination.limit) +
                index +
                1,
        },
        {
            title: "IO No",
            dataIndex: "IO_NO",
        },
        {
            title: "REV No",
            dataIndex: "REV_NO",
            align: "center",
        },
        {
            title: "Manufacturing Unit",
            dataIndex: "MNF_UNIT",
            align: "center",
        },
        {
            title: "Requested By",
            width: 200,
            dataIndex: "REQUESTED_BY",
        },
        {
            title: "Requested At",
            width: 200,
            dataIndex: "CREATED_AT",
            render: (value) =>
                dayjs(value).format("DD MMM YYYY hh:mm A"),
        },
        {
            title: "Actions",
            key: "actions",
            width: 150,
            align: "center",
            render: (_, record) => (
                <div className="flex items-center justify-center gap-3">

                    <Tooltip title="Ignore Request">
                        <X
                            size={26}
                            className="cursor-pointer text-[#667085] hover:text-[#344054] font-extrabold"
                            onClick={() => handleIgnore(record)}
                        />
                    </Tooltip>

                    <Tooltip title="Delete IO">
                        <Trash2
                            size={26}
                            className="cursor-pointer text-[#D92D20] hover:text-[#B42318] "
                            onClick={() => handleDelete(record)}
                        />
                    </Tooltip>

                </div>
            ),
        },
    ];

    return (
        <div className="p-6">
            <div className="mb-6">
                <h1 className="text-[24px] font-semibold text-[#344054]">
                    IO Deletion
                </h1>

                <p className="text-[14px] text-[#667085] mt-1">
                    Download the template, upload the records and review
                    them before confirming deletion.
                </p>
            </div>

            <div className="mb-6 rounded-lg border border-[#FDA29B] bg-[#FEF3F2] px-4 py-3">
                <div className="flex items-center justify-start gap-3">
                    <AlertTriangle
                        size={22}
                        className="text-[#D92D20]"
                    />

                    <div className="text-sm text-[#B42318] leading-6">
                        <span className="font-semibold">
                            Important:
                        </span>{" "}
                        Deleted IOs cannot be restored. Upload only
                        records that should be deleted.
                    </div>
                </div>
            </div>

            <Row gutter={16}>
                <Col xs={24} md={12}>
                    <Card
                        title="Download Template"
                        className="h-full"
                    >
                        <Space
                            direction="vertical"
                            style={{ width: "100%" }}
                        >
                            <Dragger
                                showUploadList={false}
                                openFileDialogOnClick={false}
                                onClick={() =>
                                    dispatch(
                                        downloadIoDeletionTemplate()
                                    )
                                }
                            >
                                <p className="ant-upload-drag-icon">
                                    <DownloadOutlined />
                                </p>

                                <p className="ant-upload-text">
                                    Download Excel Template
                                </p>
                                <p className="ant-upload-hint">
                                    Click to download
                                </p>
                            </Dragger>

                            <Button
                                block
                                type="primary"
                                icon={<DownloadOutlined />}
                                loading={
                                    downloadingIoDeletionTemplate
                                }
                                onClick={() =>
                                    dispatch(
                                        downloadIoDeletionTemplate()
                                    )
                                }
                            >
                                Download Template
                            </Button>
                        </Space>
                    </Card>
                </Col>

                <Col xs={24} md={12}>
                    <Card
                        title="Upload File"
                        className="h-full"
                    >
                        <Space
                            direction="vertical"
                            style={{ width: "100%" }}
                        >
                            <Dragger
                                beforeUpload={beforeUpload}
                                maxCount={1}
                                accept=".xlsx,.xls"
                                fileList={
                                    selectedFile
                                        ? [selectedFile]
                                        : []
                                }
                                onRemove={() =>
                                    setSelectedFile(null)
                                }
                            >
                                <p className="ant-upload-drag-icon">
                                    <InboxOutlined />
                                </p>

                                <p className="ant-upload-text">
                                    Click or Drag Excel File
                                </p>

                                <p className="ant-upload-hint">
                                    Only .xlsx / .xls files are
                                    supported.
                                </p>
                            </Dragger>

                            <Button
                                block
                                type="primary"
                                icon={<UploadOutlined />}
                                loading={uploadingIoDeletion}
                                disabled={!selectedFile}
                                onClick={handleUpload}
                            >
                                Upload File
                            </Button>
                        </Space>
                    </Card>
                </Col>
            </Row>


            {ioDeletionList.length > 0 && (
                <>
                    <Divider />
                    <Card
                        title="Pending Deletion Requests"

                        extra={
                            <span>
                                Total : {ioDeletionListPagination?.total || 0}
                            </span>
                        }
                    >
                        <CustomTable
                            rowKey="ID"
                            loading={gettingIoDeletionList}
                            columns={pendingColumns}
                            dataSource={ioDeletionList}
                            pagination={{
                                current:
                                    ioDeletionListPagination?.page ||
                                    listPagination.page,
                                pageSize:
                                    ioDeletionListPagination?.limit ||
                                    listPagination.limit,
                                total:
                                    ioDeletionListPagination?.total || 0,
                                showSizeChanger: true,
                                onChange: (page, pageSize) => {
                                    setListPagination({
                                        page,
                                        limit: pageSize,
                                    });

                                    fetchDeletionList(page, pageSize);
                                },
                                onShowSizeChange: (page, pageSize) => {
                                    setListPagination({
                                        page,
                                        limit: pageSize,
                                    });

                                    fetchDeletionList(page, pageSize);
                                },
                            }}
                        />
                    </Card>
                </>
            )}

            <Divider />

            <Card title="Deletion Logs">
                <CustomTable
                    rowKey="ID"
                    columns={columns}
                    dataSource={ioDeletionLogs}
                    loading={gettingIoDeletionLogs}
                    pagination={{
                        current: ioDeletionLogsPagination?.page || pagination.page,
                        pageSize: ioDeletionLogsPagination?.limit || pagination.limit, 
                        total: ioDeletionLogsPagination?.total || 0,
                        showSizeChanger: true,
                        showTotal: (total, range) =>
                            `${range[0]}-${range[1]} of ${total} records`,
                        onChange: handlePagination,
                        onShowSizeChange: handlePagination,
                    }}
                />
            </Card>

            <Modal
                open={modalOpen}
                centered
                destroyOnClose
                width={500}
                onCancel={() => setModalOpen(false)}
                onOk={handleConfirm}
                okText={modalType === "delete" ? "Delete" : "Ignore"}
                okButtonProps={{
                    danger: modalType === "delete",
                }}
                confirmLoading={
                    modalType === "delete"
                        ? deletingIoDeletion
                        : ignoringIoDeletion
                }
                title={
                    modalType === "delete"
                        ? "Delete IO?"
                        : "Ignore Deletion Request?"
                }
            >
                {selectedRecord && (
                    <>
                        <p>
                            {modalType === "delete"
                                ? <span className="text-red-500">You are about to <span className="font-bold">permanently delete </span> this Internal Order.</span>
                                : "This deletion request will be ignored."}
                        </p>

                        <div className="mt-4 rounded-lg border p-4 bg-gray-50 space-y-2">

                            <div>
                                <strong>IO No:</strong>{" "}
                                {selectedRecord.IO_NO}
                            </div>

                            <div>
                                <strong>REV No:</strong>{" "}
                                {selectedRecord.REV_NO}
                            </div>

                            <div>
                                <strong>Manufacturing Unit:</strong>{" "}
                                {selectedRecord.MNF_UNIT}
                            </div>

                        </div>

                        {modalType === "delete" && (
                            <div className="mt-4 rounded-lg border border-red-200 bg-red-50 p-3">
                                <p className="font-semibold text-red-700">
                                    Warning
                                </p>

                                <p className="text-red-600 font-semibold">
                                    This action cannot be undone.
                                </p>
                            </div>
                        )}
                    </>
                )}
            </Modal>
        </div>
    );
};

export default DeleteRevNo;